import { ListItemText, Menu, MenuItem } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { RoadNetworkViewStore } from '../../stores/nodes/road-network.view-store'

interface Props {
  viewStore: RoadNetworkViewStore
}

export const RoadNodeContextMenu = observer(({ viewStore }: Props) => {
  const { isContextMenuOpen, contextMenuTargetId, contextMenuTargetType, contextMenuPosition } =
    viewStore

  const open = isContextMenuOpen && contextMenuTargetType === 'node' && contextMenuTargetId !== null

  const handleDelete = async () => {
    if (!contextMenuTargetId) return
    await viewStore.deleteNode(contextMenuTargetId)
  }

  return (
    <Menu
      open={open}
      onClose={viewStore.closeContextMenu}
      anchorReference='anchorPosition'
      anchorPosition={
        contextMenuPosition
          ? { top: contextMenuPosition.y, left: contextMenuPosition.x }
          : undefined
      }
    >
      <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
        <ListItemText primary='Delete node' />
      </MenuItem>
    </Menu>
  )
})
